$(() => {
    var mySwiper = new Swiper ('.swiper-container3', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,

        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
    });

    var mySwiper = new Swiper ('.swiper-container2', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,

        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
    });

    if ($('#vip-map').length > 0) {
        ymaps.ready(function () {
            var myMap = new ymaps.Map('vip-map', {
                center:  [37.587874, 55.73367],
                zoom: 13
            });

            myMap.controls.add('routePanelControl', {
                autofocus: false,
            });

            var control = myMap.controls.get('routePanelControl');

            // Зададим состояние панели для построения машрутов.
            control.routePanel.state.set({
                // Тип маршрутизации.
                type: 'masstransit',
                // Выключим возможность задавать пункт отправления в поле ввода.
                fromEnabled: false,
                autofocus: false,
                // Адрес или координаты пункта отправления.
                to: [37.587874, 55.73367],
                // Включим возможность задавать пункт назначения в поле ввода.
                fromEnabled: true
                // Адрес или координаты пункта назначения.
                //to: 'Петербург'
            });

            // Зададим опции панели для построения машрутов.
            control.routePanel.options.set({
                // Запрещаем показ кнопки, позволяющей менять местами начальную и конечную точки маршрута.
                allowSwitch: false,
                autofocus: false,
                // Включим определение адреса по координатам клика.
                // Адрес будет автоматически подставляться в поле ввода на панели, а также в подпись метки маршрута.
                reverseGeocoding: true,
                // Зададим виды маршрутизации, которые будут доступны пользователям для выбора.
                types: { masstransit: false, pedestrian: false, auto: true }
            });
        });
    }
});



// WEBPACK FOOTER //
// ./src/scripts/components/vip-terminal/vip-terminal.js